<template>
    <v-layout row wrap style="max-height: 50vh;">
        <v-flex xs3>
            <div class="font-weight-bold pa-2" style="text-align: center; width: 100%; background-color: white;">
                GPS NOT WORKING
            </div>
            <v-data-table
                    :items="data.gps_not_working"
                    :headers="headers.gps_not_working"
                    hide-actions
                    :pagination.sync="pagination.gps_not_working"
            >
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.last_seen }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex xs3>
            <div class="font-weight-bold pa-2" style="text-align: center; width: 100%; background-color: white;">
                CAPTAIN OFFLINE
            </div>
            <v-data-table
                    :items="data.captain_offline"
                    :headers="headers.captain_offline"
                    hide-actions
                    :pagination.sync="pagination.captain_offline"
                    class="half-height"
            >
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.last_seen }}</td>
                        <td class="text-xs-center">{{ props.item.next_booking }}</td>
                    </tr>
                </template>
            </v-data-table>
            <div class="font-weight-bold pa-2" style="text-align: center; width: 100%; background-color: white;">
                SENT SUGGESTIONS
            </div>
            <v-data-table
                    :items="data.sent_suggestion"
                    :headers="headers.sent_suggestion"
                    hide-actions
                    :pagination.sync="pagination.sent_suggestion"
                    class="half-height"
            >
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.passenger_name }}</td>
                        <td class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.old_time }}</td>
                        <td class="text-xs-center">{{ props.item.new_time }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex xs3>
            <div class="font-weight-bold pa-2" style="text-align: center; width: 100%; background-color: white;">
                CANCELLATION
            </div>
            <v-data-table
                    :items="data.cancellation"
                    :headers="headers.cancellation"
                    hide-actions
                    :pagination.sync="pagination.cancellation"
            >
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.passenger_name }}</td>
                        <td class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.booking_time }}</td>
                        <td class="text-xs-center">{{ props.item.cancellation_time }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex xs3>
            <div class="font-weight-bold pa-2" style="text-align: center; width: 100%; background-color: white;">
                AI DISPATCH COUNT DOWN
            </div>
            <v-data-table
                    :items="data.ai_dispatch_countdown"
                    :headers="headers.ai_dispatch_countdown"
                    hide-actions
                    :pagination.sync="pagination.ai_dispatch_countdown"
            >
                <template v-slot:items="props">
                    <tr>

                        <td class="text-xs-center">{{ props.item.passenger_name }}</td>
                        <td class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td class="text-xs-center">{{ props.item.countdown }}</td>

                        <td class="text-xs-center">{{ props.item.booking_time }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import moment from "moment";

    export default {
        name: "NotificationCentre",
        mixins: [hasIntervalsMixin, socketEventsMixin],
        events() {
            return {
                "Dashboard:no_gps": this.no_gps,
                'Ai:timeline': this.ai_timeline,
                "Dashboard:offline_captains": this.offline_captains,
                "Timeline:captain_check": this.captain_check,
                "Dashboard:cancellation": this.cancellation,
                "Dashboard:sent_suggestions": this.sent_suggestions,
                [this.api.SOCKET.EVENTS.DELETE_BOOKING]: this.socketRemoveBooking,
            }
        },
        intervals() {
            return [
                [this.updateCountDown, 1000],
            ]
        },
        computed: {
            max_dispatch_time() {
                return this.$store.state.user.settings.MAX_TIME_TO_DISPATCH_AI_IN_MINUTES;
            },
            min_diff_dispatch() {
                return this.$store.state.user.settings.MIN_DIFF_BETWEEN_CREATION_AND_NOW_FOR_AI_TO_DISPATCH_IN_MINUTES;
            }

        },
        data() {

            return {
                data: {
                    gps_not_working: [
                        {
                            captain_name: "Mahmoud Test",
                            last_seen: "11:30"
                        }
                    ],
                    captain_offline: [
                        {
                            captain_id: 1,
                            captain_name: "Majd Test",
                            last_seen: "11:10",
                            next_booking: "11:20"
                        },
                    ],
                    sent_suggestion: [
                        {
                            passenger_name: "Majd Salloum",
                            captain_name: "Mahmoud Test",
                            old_time: "10:10",
                            new_time: "10:20"
                        }
                    ],
                    cancellation: [
                        {
                            passenger_name: "Majd Salloum",
                            captain_name: "Mahmoud Test",
                            booking_time: " 10:11",
                            cancellation_time: "10:05"
                        }
                    ],
                    ai_dispatch_countdown: [
                        {
                            booking_id: 10,
                            passenger_name: "Majd Salloum",
                            captain_name: "Mahmoud Test",
                            booking_time: "10:11",
                            dispatch_time: "2019-11-04 18:12"
                        }
                    ]
                },
                headers: {
                    gps_not_working: [
                        {text: "Cax", value: "captain_name", align: "center"},
                        {text: "Last Seen", value: "last_seen", align: "center"},
                    ],
                    captain_offline: [
                        {text: "Cax", value: "captain_name", align: "center"},
                        {text: "Last Seen", value: "last_seen", align: "center"},
                        {text: "Next Booking", value: "next_booking", align: "center"}
                    ],
                    sent_suggestion: [
                        {text: "Pax", value: "passenger_name", align: "center"},
                        {text: "Cax", value: "captain_name", align: "center"},
                        {text: "Old", value: "old_time", align: "center"},
                        {text: "New", value: "new_time", align: "center"},
                    ],
                    cancellation: [
                        {text: "Pax", value: "passenger_name", align: "center"},
                        {text: "Cax", value: "captain_name", align: "center"},
                        {text: "Time", value: "booking_time", align: "center"},
                        {text: "Cancel", value: "cancellation_time", align: "center"},
                    ],
                    ai_dispatch_countdown: [
                        {text: "Pax", value: "passenger_name", align: "center"},
                        {text: "Cax", value: "captain_name", align: "center"},
                        {text: "CD", value: "countdown", align: "center"},
                        {text: "Time", value: "booking_time", align: "center"}
                    ]
                },
                pagination: {
                    gps_not_working: {
                        descending: false,
                        sortBy: 'last_seen',
                        rowsPerPage: -1
                    },
                    captain_offline: {
                        descending: false,
                        sortBy: 'next_booking',
                        rowsPerPage: -1
                    },
                    send_suggestions: {
                        descending: false,
                        sortBy: 'new_time',
                        rowsPerPage: -1
                    },
                    cancellation: {
                        descending: true,
                        sortBy: "cancellation_time",
                        rowsPerPage: -1
                    },
                    ai_dispatch_countdown: {
                        descending: false,
                        sortBy: "countdown",
                        rowsPerPage: -1
                    }
                }
            }
        },
        methods: {
            socketRemoveBooking(bookingId) {
                this.data.ai_dispatch_countdown = this.data.ai_dispatch_countdown.filter(
                    ({booking_id}) => bookingId != booking_id
                );
            },
            sent_suggestions(data) {
                this.data.sent_suggestion = data;
            },
            cancellation(data) {
                this.data.cancellation = data;
            },
            captain_check(checkedCaptainId) {
                this.data.captain_offline = this
                    .data.captain_offline
                    .filter(
                        ({captain_id}) => captain_id !== checkedCaptainId
                    );
            },
            offline_captains(data) {
                this.data.captain_offline = data;
            },
            ai_timeline({workers}) {
                const requests = workers.reduce((arr, worker) => {
                    return [...arr, ...worker.worker_rides.map(i => ({captain_name: worker.worker_name, ...i}))]
                }, []);
                this.data.ai_dispatch_countdown = requests.map(
                    request => ({
                        booking_id: request.booking.id,
                        passenger_name: request.customer_name,
                        captain_name: request.captain_name,
                        booking_time: moment(request.booking.datetime).format("HH:mm"),
                        dispatch_time: moment.max(
                            moment(request.booking.created_at).startOf('minute').add(this.min_diff_dispatch + 1, 'minutes')
                            ,
                            moment(request.booking.datetime).startOf('minute').subtract(this.max_dispatch_time - 1, 'minutes')
                        )
                    })
                )
                this.updateCountDown();
            },
            no_gps(data) {
                this.data.gps_not_working = data;
            },
            updateCountDown() {
                this.data.ai_dispatch_countdown = this.data.ai_dispatch_countdown.map(
                    item => {
                        const duration = moment.duration(item.dispatch_time - moment(), 'milliseconds');
                        let minutes = duration.minutes();
                        let seconds = duration.seconds();
                        let negative = false;
                        if (seconds < 0)
                            negative = true;

                        seconds = Math.abs(seconds);
                        if (minutes < 0) {
                            minutes++;
                            minutes = Math.abs(minutes);
                            negative = true;
                        }

                        if (minutes<10)
                            minutes = "0" + minutes;

                        if (seconds < 10)
                            seconds = "0" + seconds.toString();


                        return Object.assign({}, {...item}, {countdown: `${negative ? "-" : ""}${minutes}:${seconds}`});
                    }
                );
            }
        }
    }
</script>

<style scoped>
    * >>> .v-table__overflow {
        height: calc(100vh - 64px - 50px - 40px);
        overflow-y: scroll;
        background-color: white;
    }

    .half-height >>> .v-table__overflow {
        height: calc((100vh - 64px - 50px - 60px) / 2);
    }

    * >>> *::-webkit-scrollbar {
        width: 0.5em;
    }

    * >>> *::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 1000px;
    }

    * >>> *::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
        border-radius: 1000px;

    }

</style>